module.exports = __webpack_public_path__ + "static/media/waether.5c0781a1.png";